import { useNavigate, useSearchParams } from 'react-router-dom';
import check from '/checked.png';
import { downloadPDF, downloadXML, downloadZip } from '../services/FinesServices';

export function SuccessModal() {
  const [searchParams] = useSearchParams();
  const order = searchParams.get("order");

  const handlePaymentPdf = async () => {
    try {
      if (!order) {
        console.error("Sin parámetro order al cual recurrir");
        return;
      }

      const blob = await downloadPDF(order);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `factura_${order}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error al descargar el PDF:", error);
    }
  }

    const handlePaymentXML = async () => {
    try {
      if (!order) {
        console.error("Sin parámetro order al cual recurrir");
        return;
      }

    const blob = await downloadXML(order);
	console.log(blob);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `factura_${order}.pdf`; 
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url); // Limpieza de memoria

  } catch (error) {
    console.error("Error al descargar el XML:", error);
  }
  };

   const handlePaymentAll = async () => {
    if (!order) {
      console.error("Sin parámetro order al cual recurrir");
      return;
    }

    try {
      const response = await downloadZip(order);
      console.log("PDF descargado", response);
    } catch (error) {
      console.error("Error al descargar el Zip", error);
    }
  };

    const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-200 px-4">
      <div className="w-full max-w-md bg-white p-6 rounded-lg shadow-lg">
        <div className="bg-green-100 p-6 rounded-lg shadow-md text-center">
          
          {/* Título */}
          <h2 className="text-2xl sm:text-3xl font-bold text-green-800 mb-6">
            ¡Pago realizado con éxito!
          </h2>

          {/* Imagen */}
          <div className="flex justify-center mb-6">
            <img src={check} className="w-20 sm:w-24" alt="Pago exitoso" />
          </div>

          {/* Mensaje */}
          <p className="text-gray-700 mb-8 text-base sm:text-lg">
            Su pago ha sido exitoso. Puede descargar su comprobante de pago en el siguiente botón.
          </p>

          {/* Botones */}
          <div className="flex flex-col gap-4 items-center">
            <button
              className="w-full sm:w-64 bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition"
              onClick={handlePaymentPdf}
            >
              Descargar PDF
            </button>

            <button
              className="w-full sm:w-64 bg-gray-400 text-black py-2 rounded-lg hover:bg-gray-500 transition"
              onClick={() => navigate("/multasdetransito/")}
            >
              Volver
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
